// Import dependencies
import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { NavLink } from "react-router-dom";

// Import lottie components
import Gear from "../Lotties/Gear";

// Import data content
import { content } from "../assets/data/Content";

// Import components
import Helmet from "../components/Helmet/Helmet";
import ProjectCard from "../components/ProjectCard/ProjectCard";

// Import styles & icons
import { Container, Row, Col } from "reactstrap";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "../PageStyle/Projects.css";

const Projects = () => {
  // Content
  const { projects } = content;

  // State for selected category
  const [category, setCategory] = useState("ALL");

  // State for all projects
  const [allProjects, setAllProjects] = useState([...projects.projectContent]);

  // Page current
  const [pageNumber, setPageNumber] = useState(0);

  // Props for pagination
  const projectPerPage = 4;
  const visitedPage = pageNumber * projectPerPage;
  const displayPage = allProjects.slice(
    visitedPage,
    visitedPage + projectPerPage
  );
  const pageCount = Math.ceil(allProjects.length / projectPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Filter all projects
  useEffect(() => {
    if (category === "ALL") {
      setAllProjects(projects.projectContent);
    }

    if (category === "WEB") {
      const filteredProject = projects.projectContent.filter(
        (project) => project.category === "Web"
      );

      setAllProjects(filteredProject);
    }

    if (category === "APP") {
      const filteredProject = projects.projectContent.filter(
        (project) => project.category === "App"
      );

      setAllProjects(filteredProject);
    }

    if (category === "PRACTICA") {
      const filteredProject = projects.projectContent.filter(
        (project) => project.category === "Práctica"
      );

      setAllProjects(filteredProject);
    }
  }, [category, projects.projectContent]);
  return (
    <>
      <Helmet title="Proyectos">
        <section className="bg-bg_light_primary h-[100vh]">
          <div className="bg-bg_light_primary h-auto">
            {/* Title & subtitle */}
            <div className="p-8 m-0">
              <h2 className="title" data-aos="fade-left">
                {projects.title}
              </h2>

              <h4 className="subtitle" data-aos="fade-right">
                {projects.subtitle}
              </h4>
            </div>

            <Container>
              {/* Filter */}
              <Row>
                <div className="flex items-center justify-center text-center my-4 py-3 rounded-xl gap-[10px]">
                  <button
                    className={`text-dark_secondary text-xs md:text-lg font-bold py-1 px-3 ${
                      category === "ALL" ? "filterBtnActive" : ""
                    }`}
                    onClick={() => setCategory("ALL")}
                  >
                    Todo
                  </button>
                  <button
                    className={`text-dark_secondary text-xs md:text-lg font-bold py-1 px-3 ${
                      category === "WEB" ? "filterBtnActive" : ""
                    }`}
                    onClick={() => setCategory("WEB")}
                  >
                    Páginas Web
                  </button>
                  <button
                    className={`text-dark_secondary text-xs md:text-lg font-bold py-1 px-3 ${
                      category === "APP" ? "filterBtnActive" : ""
                    }`}
                    onClick={() => setCategory("APP")}
                  >
                    Aplicaciones
                  </button>
                  <button
                    className={`text-dark_secondary text-xs md:text-lg font-bold py-1 px-3 ${
                      category === "PRACTICA" ? "filterBtnActive" : ""
                    }`}
                    onClick={() => setCategory("PRACTICA")}
                  >
                    Práctica
                  </button>
                </div>
              </Row>

              {/* Project Card */}
              <Row xs={1} md={2} lg={4}>
                {displayPage.map((project, index) => (
                  <Col key={index}>
                    <ProjectCard project={project} />
                  </Col>
                ))}
              </Row>

              {/* Pagination */}
              <ReactPaginate
                pageCount={pageCount}
                onPageChange={changePage}
                previousLabel={<IoIosArrowBack />}
                nextLabel={<IoIosArrowForward />}
                containerClassName="paginationBttns"
              ></ReactPaginate>
            </Container>
          </div>
        </section>
        {/* Return */}
        <NavLink
          to={"/home"}
          className="block fixed right-[-2rem] bottom-0 h-[120px] z-[1]"
        >
          <Gear />
        </NavLink>
      </Helmet>
    </>
  );
};

export default Projects;
